/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class CloudResourceConfiguration {
  /**
  * Whether CDC is enabled for the resource
  */
  'enableCdcBackup': boolean;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "enableCdcBackup",
      "baseName": "enableCdcBackup",
      "type": "boolean",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return CloudResourceConfiguration.attributeTypeMap;
  }

  public constructor() {
  }
}

